export const teamsMenuI18NPl = {
    allTeams: "Wszystkie zespoły",
    myTeams: "Moje",
    addTeam: "Stwórz zespół",
    removeTeam: (name: string) => `Usuń ${name}`,
    removeTeamNotice: (name: string) => `Czy na pewno chcesz zespół '${name}'?`,
};
